import { Injectable, OnInit } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from './../../environments/environment';
import { map } from "rxjs/operators";
import { BehaviorSubject, Subject } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class AuthService implements OnInit {
  private messageSource = new BehaviorSubject<Number>(0);
  currentMessage = this.messageSource.asObservable()
  private apiUrl = environment.apiUrl
  partner: any = {}
  isLoggedin: boolean = localStorage.getItem('token') ? true : false
  isLoggedinForHome = new BehaviorSubject<boolean>(false)
  pharmacyUpdateKeys = ['profilePicture', 'name', 'phoneNo', 'alternateNumber', 'city', 'lat', 'lng', 'address', 'images', 'registrationNo', 'about', 'discount', 'email', 'awards', 'membership', 'regImage', 'password']
  hospitalUpdateKeys = ['services', 'countryCode', 'coverPhoto', 'name', 'lat', 'lng', 'city', 'address', 'phoneNo', 'alternateNumber', 'registrationNo', 'fees', 'website', 'discount', 'email', 'awards', 'membership', 'regImage', 'description', 'speciality', 'password', 'images']
  doctorUpdateKeys = ['services', 'regImage', 'email', 'countryCode', 'profilePicture', 'name', 'phoneNo', 'alternateNumber', 'lat', 'lng', 'address', 'images', 'registrationNo', 'about', 'discount', 'email', 'awards', 'membership', 'regImage', 'city', 'education', 'experience', 'awards', 'consultantFees', 'speciality', 'languages', 'gender', 'password']
  labUpdateKeys = ['countryCode', 'profilePicture', 'name', 'phoneNo', 'alternateNumber', 'gender', 'lat', 'lng', 'address', 'city', 'consultantFees', 'education', 'experience', 'images', 'registrationNo', 'about', 'discount', 'email', 'awards', 'languages', 'membership', 'speciality', 'regImage', 'password']
  userUpdateKeys = ['countryCode', 'profilePicture', 'name', 'email', 'phoneNo', 'houseNo', 'alternateNumber', 'gender', 'lat', 'lng', 'address', 'city', 'state', 'country', 'pincode', 'education', 'languages', 'gender', 'dob', 'bloodGroup', 'documents', 'about', 'password']

  constructor(private http: HttpClient) { }
  ngOnInit() {

    let token = localStorage.getItem('token')
    // console.log(token)
    this.isLoggedin = token ? true : false
    if (this.isLoggedin)
      this.partner = JSON.parse(localStorage.getItem('logindata'))
    else
      this.partner.phoneNo = ''
  }
  changeMessage() {

    this.messageSource.next(Math.random())
  }


  getLocation(): Promise<any> {
    return new Promise((resolve, reject) => {

      navigator.geolocation.getCurrentPosition(resp => {

        resolve({ lng: resp.coords.longitude, lat: resp.coords.latitude, nolocation: 0 });
      },
        err => {
          resolve({ nolocation: 1 })
        });
    });

  }

  getOtp(phoneNo: any, type: string, countryCode = '+91') {
    let obj = { phoneNo: phoneNo, countryCode: countryCode };
    let newType = type;
    if (type == 'User') {
      return this.http.post(`${this.apiUrl}/${type}/Login`, obj)
    } else {
      if(type == 'Blood_bank') {
        newType = 'Pharmecy';
        obj['type'] = 'BLOOD_BANK';
      }
      return this.http.post(`${this.apiUrl}/${newType}/Login`, obj)
    }


  }
  checkPasswordStatus(phoneNo) {
    return this.http.post(`${this.apiUrl}/User/checkPasswordStatus`, { phoneNo: phoneNo })
  }
  checkOtpfunc(phoneNo, otp: String, type: string, countryCode = '+91') {

    let obj = { phoneNo: phoneNo, otp: otp, countryCode: countryCode };
    let newType = type;

    if (type == 'User') {
      return this.http.post(`${this.apiUrl}/${type}/OtpVerification`,
      obj)
        .pipe(map(res => {
          // console.log(otp)
          if (res['statusCode'] == 200) {
            this.isLoggedin = true
            localStorage.setItem('logindata', JSON.stringify(res['data']))
            localStorage.setItem('token', res['data']['accessToken'])
            localStorage.setItem('usertype', type)
            if (type == 'User') {
              // this.isLoggedinForHome.next(true);
              localStorage.setItem('phoneNo', phoneNo)
            }
            return res['message']

          }
          return res['message']


        }))
    } else {
      if(type == 'Blood_bank') {
        newType = 'Pharmecy';
      }
      return this.http.post(`${this.apiUrl}/${newType}/OtpVerification`,
      obj)
        .pipe(map(res => {
          // console.log(otp)
          if (res['statusCode'] == 200) {
            this.isLoggedin = true
            localStorage.setItem('logindata', JSON.stringify(res['data']))
            localStorage.setItem('token', res['data']['accessToken'])
            localStorage.setItem('usertype', type)
            if (type == 'User') {
              // this.isLoggedinForHome.next(true);
              localStorage.setItem('phoneNo', phoneNo)
            }
            return res['message']

          }
          return res['message']


        }))
    }


  }
  forgotPassUser(phoneNo, countryCode = '+91') {
    return this.http.post(`${this.apiUrl}/User/forgotPassword`, { phoneNo: phoneNo, countryCode: countryCode })
  }
  forgotPass(phoneNo, type, countryCode = '+91') {

    let typePartner
    console.log(type)
    if (type == 'Doctor') {
      typePartner = 1
    }
    else if (type == 'Pharmecy') {
      typePartner = 2
    }
    else if (type == 'Labs') {
      typePartner = 3
    }
    else if (type == 'Hospital') {
      typePartner = 4
    }
    console.log(typePartner)
    return this.http.post(`${this.apiUrl}/Doctor/forgotPassword`, { phoneNo: phoneNo, type: typePartner, countryCode: countryCode })
  }

  checkPassfunc_user(phoneNo, pass: String, type: string, countryCode = '+91') {
    return this.http.post(`${this.apiUrl}/${type}/loginWithPassword`,
      { phoneNo: phoneNo, password: pass, countryCode: countryCode })
      .pipe(map(res => {
        // console.log(otp)
        if (res['statusCode'] == 200) {
          this.isLoggedin = true
          localStorage.setItem('logindata', JSON.stringify(res['data']['data']))
          localStorage.setItem('token', res['data']['data']['accessToken'])
          localStorage.setItem('usertype', type)
          if (type == 'User') {
            // this.isLoggedinForHome.next(true);
            localStorage.setItem('phoneNo', phoneNo)
          }
          return res['message']

        }
        return res['message']


      }))
  }
  checkPassfunc(phoneNo, pass: String, type: string, countryCode = '+91') {
    let newType = type;
    if(type == 'Blood_bank') {
      newType = 'Pharmecy'; 
    }
    return this.http.post(`${this.apiUrl}/${newType}/passwordLogin`,
      { phoneNo: phoneNo, password: pass, countryCode: countryCode })
      .pipe(map(res => {
        // console.log(otp)
        if (res['statusCode'] == 200) {
          this.isLoggedin = true
          localStorage.setItem('logindata', JSON.stringify(res['data']))
          localStorage.setItem('token', res['data']['accessToken'])
          localStorage.setItem('usertype', type)
          if (type == 'User') {
            // this.isLoggedinForHome.next(true);
            localStorage.setItem('phoneNo', phoneNo)
          }
          return res['message']

        }
        return res['message']


      }))
  }
  listReminder() {
    let token = localStorage.getItem('token')
    let headers = new HttpHeaders({
      'content-Type': 'application/json',
      'authorization': 'Bearer ' + token,
      'accept': 'application/json',

    });

    return this.http.get(`${this.apiUrl}/User/listReminder`, { headers: headers })
  }
  setReminder(reminderObj) {
    let token = localStorage.getItem('token')
    let headers = new HttpHeaders({
      'content-Type': 'application/json',
      'authorization': 'Bearer ' + token,
      'accept': 'application/json',

    });
    delete reminderObj["time"]
    reminderObj["time"] = reminderObj["timeStamp"]
    delete reminderObj["timeStamp"]
    let obj = {
      ...reminderObj,
      //_id:userId
    }

    return this.http.post(`${this.apiUrl}/User/addEditReminder`, obj, { headers: headers })
  }
  deleteReminder(reminderId) {
    let token = localStorage.getItem('token')
    let headers = new HttpHeaders({
      'content-Type': 'application/json',
      'authorization': 'Bearer ' + token,
      'accept': 'application/json',

    });
    return this.http.post(`${this.apiUrl}/User/deleteReminder`, { _id: reminderId }, { headers: headers })


  }

  chatBooking(chatData) {
    let token = localStorage.getItem('token')
    let headers = new HttpHeaders({
      'content-Type': 'application/json',
      'authorization': 'Bearer ' + token,
      'accept': 'application/json',

    });

    return this.http.post(`${this.apiUrl}/User/chat_booking`, chatData, { headers: headers })
  }
  pdfFileUpload(file) {
    let formData = new FormData();
    formData.append("file", file);

    let token = localStorage.getItem('token')

    let fileHeaders = new HttpHeaders({
      'authorization': 'Bearer ' + token,
      //   'Content-Type': 'multipart/form-data',
      'accept': 'application/json'
    })
    return this.http.post(`${this.apiUrl}/Upload/pdfUpload`, formData, { headers: fileHeaders })
  }
  fileUpload(file) {
    let formData = new FormData();
    formData.append("file", file);

    let token = localStorage.getItem('token')

    let fileHeaders = new HttpHeaders({
      'authorization': 'Bearer ' + token,
      //   'Content-Type': 'multipart/form-data',
      'accept': 'application/json'
    })
    return this.http.post(`${this.apiUrl}/Upload/images`, formData, { headers: fileHeaders })
  }
  profileUpdate(type: String, data: any) {
    let token = localStorage.getItem('token')
    let headers = new HttpHeaders({
      'content-Type': 'application/json',
      'authorization': 'Bearer ' + token,
      'accept': 'application/json',

    });
    if (type == 'doctor') {
      // For doctor

      let doctorUpdateKeys = this.doctorUpdateKeys
      Object.keys(data).forEach(function (key) {

        let exist = doctorUpdateKeys.find(ob => ob == key);
        if (exist == null)
          delete data[key]

      });

      console.log(data)
      if (!data['discount'])
        data['discount'] = 0
      if (!data['alternateNumber'])
        delete data['alternateNumber']
      if (!data['email'])
        delete data['email']
      if (!data['consultantFees'])
        delete data['consultantFees']
      if (typeof data['consultantFees'] !== 'number')
        data['consultantFees'] = 0
      return this.http.put(`${this.apiUrl}/Doctor/editProfile`, data, { headers: headers })
    }
    else if (type == 'hospital') {

      let hospitalUpdateKeys = this.hospitalUpdateKeys
      Object.keys(data).forEach(function (key) {

        let exist = hospitalUpdateKeys.find(ob => ob == key);
        if (exist == null)
          delete data[key]

      });

      if (!data['discount'])
        data['discount'] = 0
      if (!data['alternateNumber'])
        delete data['alternateNumber']
      console.log(data)

      return this.http.put(`${this.apiUrl}/Hospital/editHospital`, data, { headers: headers })

    }
    else if (type == 'lab') {

      let labUpdateKeys = this.labUpdateKeys
      Object.keys(data).forEach(function (key) {

        let exist = labUpdateKeys.find(ob => ob == key);
        if (exist == null)
          delete data[key]

      });
      if (!data['discount'])
        data['discount'] = 0
      if (!data['alternateNumber'])
        delete data['alternateNumber']
      console.log(data)

      return this.http.put(`${this.apiUrl}/Labs/editLab`, data, { headers: headers })
    }
    else if (type == 'pharmacy') {

      let pharmacyUpdateKeys = this.pharmacyUpdateKeys
      Object.keys(data).forEach(function (key) {

        let exist = pharmacyUpdateKeys.find(ob => ob == key);
        if (exist == null)
          delete data[key]

      });

      if (!data['discount'])
        data['discount'] = 0
      if (!data['alternateNumber'])
        delete data['alternateNumber']




      console.log(data)
      return this.http.put(`${this.apiUrl}/Pharmecy/editPharmecy`, data, { headers: headers })
    }
    else if (type == 'user') {


      let userUpdateKeys = this.userUpdateKeys
      Object.keys(data).forEach(function (key) {

        let exist = userUpdateKeys.find(ob => ob == key);
        if (exist == null || data[key] == '' || !data[key])
          delete data[key]

      });

      data["houseNo"] = "2345"
      console.log(data)
      return this.http.put(`${this.apiUrl}/User/editUser`, data, { headers: headers })
    }
  }

  async getPartner() {


    // console.log(token)




  }
  public logout() {
    this.isLoggedin = false
    if (localStorage.getItem('usertype') == 'User') {
      this.isLoggedinForHome.next(false);
    }
    localStorage.clear()

  }

  bookAmbulance(bookingData: any) {
    let token = localStorage.getItem('token')
    let headers = new HttpHeaders({
      'content-Type': 'application/json',
      //'content-Type': 'application/x-www-form-urlencoded',
      'authorization': 'Bearer ' + token,
      'accept': 'application/json',

    });

    return this.http.post(`${this.apiUrl}/User/bookAmbulance`, bookingData, { headers: headers })
  }
  
  loginaccessToken(type: string) {
    let token = localStorage.getItem('token')
    let headers = new HttpHeaders({
      'content-Type': 'application/json',
      //'content-Type': 'application/x-www-form-urlencoded',
      'authorization': 'Bearer ' + token,
      'accept': 'application/json',

    });
    // console.log(headers)
    return this.http.post(`${this.apiUrl}/${type}/accessTokenLogin`, {}, { headers: headers })
  }
  getMapData() {
    let token = localStorage.getItem('token')
    let headers = new HttpHeaders({
      'content-Type': 'application/json',
      //'content-Type': 'application/x-www-form-urlencoded',
      'authorization': 'Bearer ' + token,
      'accept': 'application/json',

    });
    return this.http.get(`${this.apiUrl}/User/getMapData`, { headers: headers })
  }
  getMapDataWithoutToken(userId) {
    let params = {}
    params['userId'] = userId


    const httpOptions = {

      params: params
    };
    return this.http.get(`${this.apiUrl}/User/getMapDataWithoutToken`, httpOptions)
  }

  // async getStorage(){
  //   let token = await localStorage.getItem('token')
  //   let user = await localStorage.getItem('logindata')
  //   this.user = JSON.parse(user)
  //   console.log("SET", this.user)
  //   this.isLoggedin = token ? true : false
  // }
  setPasword(password) {
    let accesstoken = localStorage.getItem('token')
    let headers1 = new HttpHeaders({
      'content-Type': 'application/json',
      'authorization': 'Bearer ' + accesstoken,
      'accept': 'application/json',

    });
    let usertype = localStorage.getItem('usertype');

    let obj = { password: password };
    let newType = usertype;

    if (usertype == 'User') {
      return this.http.put(`${this.apiUrl}/${usertype}/editUser`, obj, { headers: headers1 })
    }
    else {

      if(usertype == 'Blood_bank') {
        newType = 'Pharmecy';
        obj['type'] = 'BLOOD_BANK';
      }

      return this.http.put(`${this.apiUrl}/${newType}/setPassword`, obj, { headers: headers1 })
    }
  }
  doctorBooking(doctorBookingData) {
    let accesstoken = localStorage.getItem('token')
    let headers1 = new HttpHeaders({
      'content-Type': 'application/json',
      'authorization': 'Bearer ' + accesstoken,
      'accept': 'application/json',

    });

    return this.http.post(`${this.apiUrl}/User/doctorBooking`, doctorBookingData, { headers: headers1 })
  }
  getDoctorBookings() {
    let accesstoken = localStorage.getItem('token')
    let headers1 = new HttpHeaders({
      'content-Type': 'application/json',
      'authorization': 'Bearer ' + accesstoken,
      'accept': 'application/json',

    });

    return this.http.get(`${this.apiUrl}/User/listDcotorBookings`, { headers: headers1 })
  }
  getSingleBlog(id) {
    let params = {}
    params['_id'] = id


    const httpOptions = {

      params: params
    };

    return this.http.get(`${this.apiUrl}/User/listSingleBolg`, httpOptions)


  }
  getUserHistory(date = null) {
    let accesstoken = localStorage.getItem('token')
    let headers1 = new HttpHeaders({
      'content-Type': 'application/json',
      'authorization': 'Bearer ' + accesstoken,
      'accept': 'application/json',

    });
    if (date)
      return this.http.get(`${this.apiUrl}/User/userHistory?date=${date}`, { headers: headers1 })
    else
      return this.http.get(`${this.apiUrl}/User/userHistory`, { headers: headers1 })


    // return this.http.get(`${this.apiUrl}/User/userHistory`,{headers:headers1})
  }
  cancelAmbulanceBooking(bookingId) {
    let accesstoken = localStorage.getItem('token')
    let headers1 = new HttpHeaders({
      'content-Type': 'application/json',
      'authorization': 'Bearer ' + accesstoken,
      'accept': 'application/json',

    });
    return this.http.put(`${this.apiUrl}/User/cancelBooking`, { _id: bookingId }, { headers: headers1 })
  }
  addReview(reviewObj, reviewType) {
    let accesstoken = localStorage.getItem('token')
    let headers1 = new HttpHeaders({
      'content-Type': 'application/json',
      'authorization': 'Bearer ' + accesstoken,
      'accept': 'application/json',

    });
    if (reviewType == 'doctor')
      return this.http.put(`${this.apiUrl}/User/addReview`, reviewObj, { headers: headers1 })
    else if (reviewType == 'pharmacy')
      return this.http.put(`${this.apiUrl}/User/addPharmecyReview`, reviewObj, { headers: headers1 })
    else if (reviewType == 'lab')
      return this.http.put(`${this.apiUrl}/User/addLabReview`, reviewObj, { headers: headers1 })
    else if (reviewType == 'hospital')
      return this.http.put(`${this.apiUrl}/User/addHospitalReview`, reviewObj, { headers: headers1 })


  }

  listMessages(doctorId) {
    let accesstoken = localStorage.getItem('token')
    let headers1 = new HttpHeaders({
      'content-Type': 'application/json',
      'authorization': 'Bearer ' + accesstoken,
      'accept': 'application/json',

    });
    return this.http.get(`${this.apiUrl}/User/listMessages?skip=0`, { headers: headers1, params: { doctorId: doctorId } })
  }
  sendMessage(doctorID, message, messageType = 'TEXT') {
    let accesstoken = localStorage.getItem('token')
    let headers1 = new HttpHeaders({
      'content-Type': 'application/json',
      'authorization': 'Bearer ' + accesstoken,
      'accept': 'application/json',

    });
    let params = {}
    params['doctorId'] = doctorID
    params['message'] = message
    params['messageType'] = messageType


    const httpOptions = {

      params: params
    };
    return this.http.post(`${this.apiUrl}/User/sendMessage`, params, { headers: headers1 })
  }
  deleteReport(report) {
    let accesstoken = localStorage.getItem('token')
    let headers1 = new HttpHeaders({
      'content-Type': 'application/json',
      'authorization': 'Bearer ' + accesstoken,
      'accept': 'application/json',

    });
    console.log(report)
    return this.http.put(`${this.apiUrl}/User/deleteReports`, { reports: report }, { headers: headers1 })
  }
  documentsUpdate(reports, name) {
    let accesstoken = localStorage.getItem('token')
    let headers1 = new HttpHeaders({
      'content-Type': 'application/json',
      'authorization': 'Bearer ' + accesstoken,
      'accept': 'application/json',

    });

    return this.http.put(`${this.apiUrl}/User/editUser`, { name: name, documents: reports }, { headers: headers1 })
  }
  getUserDetail() {
    let accesstoken = localStorage.getItem('token')
    let headers1 = new HttpHeaders({
      'content-Type': 'application/json',
      'authorization': 'Bearer ' + accesstoken,
      'accept': 'application/json',

    });
    return this.http.get(`${this.apiUrl}/User/accessTokenLogin`, { headers: headers1 })
  }
  applyMedicalTourism(tourismObject) {

    return this.http.post(`${this.apiUrl}/User/apply4medicalTourism`, tourismObject)
  }
  getHtml(type) {
    return this.http.get(`${this.apiUrl}/User/listOtherDetails?uniquekey=${type}`)
  }
  addBlogReview(data) {
    let accesstoken = localStorage.getItem('token')
    let headers1 = new HttpHeaders({
      'content-Type': 'application/json',
      'authorization': 'Bearer ' + accesstoken,
      'accept': 'application/json',

    });
    return this.http.put(`${this.apiUrl}/User/addBlogReview`, data, { headers: headers1 })

  }


  searchBlog(search, type) {
    let params = {}
    params['search'] = search
    if (type == 'YOGA' || type == 'HEALTH')
      params['type'] = type


    const httpOptions = {

      params: params
    };
    return this.http.get(`${this.apiUrl}/User/searchBlogs`, httpOptions)
  }
  listPlans() {
    let accesstoken = localStorage.getItem('token')
    let headers1 = new HttpHeaders({
      'content-Type': 'application/json',
      'authorization': 'Bearer ' + accesstoken,
      'accept': 'application/json',

    });
    return this.http.get(`${this.apiUrl}/User/list_plans`, { headers: headers1 })
  }
  buyPlan(data) {
    let accesstoken = localStorage.getItem('token')
    let headers1 = new HttpHeaders({
      'content-Type': 'application/json',
      'authorization': 'Bearer ' + accesstoken,
      'accept': 'application/json',

    });
    return this.http.post(`${this.apiUrl}/User/select_plan`, data, { headers: headers1 })
  }
  walletBalance() {
    let accesstoken = localStorage.getItem('token')
    let headers1 = new HttpHeaders({
      'content-Type': 'application/json',
      'authorization': 'Bearer ' + accesstoken,
      'accept': 'application/json',

    });
    return this.http.get(`${this.apiUrl}/User/view_wallet_balance`, { headers: headers1 })
  }
  walletLogs() {
    let accesstoken = localStorage.getItem('token')
    let headers1 = new HttpHeaders({
      'content-Type': 'application/json',
      'authorization': 'Bearer ' + accesstoken,
      'accept': 'application/json',

    });

    return this.http.get(`${this.apiUrl}/User/list_logs?type=WALLET_LOGS`, { headers: headers1 })
  }
  addWalletAmount(amount) {
    let accesstoken = localStorage.getItem('token')
    let headers1 = new HttpHeaders({
      'content-Type': 'application/json',
      'authorization': 'Bearer ' + accesstoken,
      'accept': 'application/json',

    });
    return this.http.put(`${this.apiUrl}/User/update_wallet_balance`, { amount: amount }, { headers: headers1 })
  }

  getProfile() {
    let accesstoken = localStorage.getItem('token')
    let headers1 = new HttpHeaders({
      'content-Type': 'application/json',
      'authorization': 'Bearer ' + accesstoken,
      'accept': 'application/json',

    });
    return this.http.get(`${this.apiUrl}/User/userProfile`, { headers: headers1 })
  }

  postData(url , obj) {
    let accesstoken = localStorage.getItem('token')
    let headers1 = new HttpHeaders({
      'content-Type': 'application/json',
      'authorization': 'Bearer ' + accesstoken,
      'accept': 'application/json',

    });
    return this.http.post(`${this.apiUrl}${url}`, obj, { headers: headers1 })
  }

  getData(url , obj) {
    let accesstoken = localStorage.getItem('token')
    let headers1 = new HttpHeaders({
      'content-Type': 'application/json',
      'authorization': 'Bearer ' + accesstoken,
      'accept': 'application/json',

    });
    return this.http.get(`${this.apiUrl}${url}`, { params: obj, headers: headers1 })
  }

  isUserLogin = new Subject();

  updateUserFCMToken(obj) {
    let accesstoken = localStorage.getItem('token')
    let headers1 = new HttpHeaders({
      'content-Type': 'application/json',
      'authorization': 'Bearer ' + accesstoken,
      'accept': 'application/json',

    });
    return this.http.put(`${environment.apiUrl}/User/update_web_token`, obj, { headers: headers1 })
    .pipe(map((response: any) => {
      return response;
    }));
  }

  updateOtherFCMToken(type, obj) {
    let accesstoken = localStorage.getItem('token')
    let headers1 = new HttpHeaders({
      'content-Type': 'application/json',
      'authorization': 'Bearer ' + accesstoken,
      'accept': 'application/json',

    });
    let newType = type
    if(type == 'Blood_bank') {
      newType = 'Pharmecy';
    }
    return this.http.put(`${environment.apiUrl}/${newType}/update_web_token`, obj, { headers: headers1 })
    .pipe(map((response: any) => {
      return response;
    }));
  }

  getNotifications(type, obj) {
    let accesstoken = localStorage.getItem('token')
    let headers1 = new HttpHeaders({
      'content-Type': 'application/json',
      'authorization': 'Bearer ' + accesstoken,
      'accept': 'application/json',

    });
    return this.http.get(`${environment.apiUrl}/${type}/list_notifications`, { headers: headers1 })
    .pipe(map((response: any) => {
      return response;
    }));
  }

  getUserNotifications(type, obj) {
    let accesstoken = localStorage.getItem('token')
    let headers1 = new HttpHeaders({
      'content-Type': 'application/json',
      'authorization': 'Bearer ' + accesstoken,
      'accept': 'application/json',

    });
    return this.http.get(`${environment.apiUrl}/${type}/listNotification`, { headers: headers1 })
    .pipe(map((response: any) => {
      return response;
    }));
  }

  clearNotificaitons(type, obj) {
    let accesstoken = localStorage.getItem('token')
    let headers1 = new HttpHeaders({
      'content-Type': 'application/json',
      'authorization': 'Bearer ' + accesstoken,
      'accept': 'application/json',

    });
    return this.http.put(`${environment.apiUrl}/${type}/manage_notifications`, obj, { headers: headers1 })
    .pipe(map((response: any) => {
      return response;
    }));
  }

  listSpecialities() {
    let token = localStorage.getItem('token')
    let headers = new HttpHeaders({
      'content-Type': 'application/json',
      //'content-Type': 'application/x-www-form-urlencoded',
      'authorization': 'Bearer ' + token,
      'accept': 'application/json',

    });

    return this.http.get(`${this.apiUrl}/User/list_specialities`, { headers: headers })
    .pipe(map((response: any) => {
      return response;
    }));
  }

  notification = new Subject();

  setNotification(data) {
    this.notification.next(data);
  }

}
